module.exports = __webpack_public_path__ + "static/fonts/MuseoSans_900.f5d070fc.otf";